import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { Customer } from '../../../../services/kingfisher/customer';

@Injectable({
  providedIn: 'root',
})
export class FidelitySubscribeStoreService {
  private readonly _customer = signal<Customer | null>(null);

  /**
   * Émis avec l'identifiant du client lorsqu'une carte de fidélité
   * vient d'être créée avec succès. Permet au composant parent de
   * rafraîchir la liste et d'ouvrir le détail de la carte créée.
   */
  readonly cardCreated$ = new Subject<string>();

  /** Client en cours d'inscription ; `null` si le wizard d'inscription est fermé. */
  readonly customer = this._customer.asReadonly();

  setCustomer(customer: Customer): void {
    this._customer.set(customer);
  }

  reset(): void {
    this._customer.set(null);
  }
}
